(() => {
  const STORAGE_KEY = 'pierle_gate_success';
  const RETURN_URL = '/collections/all';

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const gate = document.querySelector('[data-pierle-gate]');
    if (!gate) return;

    let isApproved = false;
    try {
      isApproved = localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      console.warn('PIERLE gate storage okunamadı:', error);
    }

    if (isApproved) {
      gate.remove();
      document.body.classList.remove('pierle-lock');
      return;
    }

    const form = gate.querySelector('#pierle-gate-form');
    const card = gate.querySelector('.pierle-gate__card');
    const firstField = gate.querySelector('input:not([type="hidden"]), select');
    const companyTypeInputs = [...gate.querySelectorAll('input[name="contact[note][Şirket Türü]"]')];
    const companyNameField = gate.querySelector('[data-pierle-company-name]');
    const companyNameInput = companyNameField?.querySelector('input');
    const footerBoxes = gate.querySelector('.pierle-footer-boxes');

    /* Güven kutularını mevcut tasarımdaki gibi formun üstünde tut. */
    if (footerBoxes && form?.parentNode) form.parentNode.insertBefore(footerBoxes, form);

    const revealCompanyName = (focus = false) => {
      if (!companyNameField || !companyNameInput) return;
      companyNameField.hidden = false;
      companyNameInput.disabled = false;
      if (focus) window.setTimeout(() => companyNameInput.focus({ preventScroll:true }), 120);
    };

    companyTypeInputs.forEach(input => {
      input.addEventListener('change', () => revealCompanyName(false));
    });

    revealCompanyName(false);

    const showGate = () => {
      gate.hidden = false;
      document.body.classList.add('pierle-lock');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          gate.classList.add('is-visible');
          window.setTimeout(() => firstField?.focus({ preventScroll: true }), 320);
        });
      });
    };

    showGate();

    gate.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !card) return;

      const focusable = [...card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => element.offsetParent !== null);

      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (!form) return;

    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;

      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = RETURN_URL;

      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (error) {
        console.warn('PIERLE gate storage yazılamadı:', error);
      }

      const button = form.querySelector('.pierle-submit');
      const label = button?.querySelector('span');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      if (label) label.textContent = 'KAYDEDİLİYOR...';
    });
  });
})();
